<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="d-flex">
      <template v-slot:default="{ open }">
        <span class="font-weight-medium text-h6">Mensagens</span>
        <div
          v-if="open"
          class="d-flex justify-end mr-2"
        >
          <secao-default-chip></secao-default-chip>
        </div>
      </template>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <chat-mensagens></chat-mensagens>

      <v-divider class="mt-5"></v-divider>

      <v-row class="justify-md-space-between justify-end mt-5 pb-2">
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            label="Status Ticket:"
            dense
            outlined
            item-text="nome"
            item-value="id"
            hide-details
            :items="[]"
          ></v-select>
        </v-col>

        <div class="d-flex">
          <v-col cols="auto">
            <v-btn
              color="primary"
              outlined
            >
              Encaminhar ticket
            </v-btn>
          </v-col>

          <v-col
            cols="auto"
          >
            <v-btn
              color="primary"
              outlined
            >
              Salvar
            </v-btn>
          </v-col>
        </div>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import SecaoDefaultChip from '../SecaoDefaultChip.vue'
import ChatMensagens from './ChatMensagens.vue'

export default {
  components: {
    SecaoDefaultChip,
    ChatMensagens,
  },
}
</script>
